import Collapse from '../../../../shared/assets/images/png/menuCollapse.png';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const MenuCollapse = styled.img`
  bottom: 0;
  left: ${16 * Screen.widthRatio}px;
  height: ${30 * Screen.widthRatio}px;
  position: absolute;
  margin: auto;
  top: 0;
  width: ${30 * Screen.widthRatio}px;
`;

MenuCollapse.defaultProps = {
  src: Collapse,
};

export default withImage(MenuCollapse);
